import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { WarehousingAbnormalService } from '../../../services/warehousing-abnormal.service';

@Component({
  selector: 'laas-warehousing-abnormal-tracking-for-shipping',
  templateUrl: './warehousing-abnormal-tracking-for-shipping.component.html',
  styleUrls: ['./warehousing-abnormal-tracking-for-shipping.component.scss']
})
export class WarehousingAbnormalTrackingForShippingComponent extends SessionBaseComponent implements OnInit {

  @Input() params: any;
  @Output() visibleChange: EventEmitter<any>;
  isVisible: boolean;

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }
  importFailForm!: FormGroup;
  importFailParams: any;

  /* Text */
  importFailText: { importFailReason: string | null, remarks: string | null } = { importFailReason: null, remarks: null };


  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private warehousingAbnormalService: WarehousingAbnormalService,
  ) {
    super(injector);
    this.isVisible = false;
    this.visibleChange = new EventEmitter<any>();

    this.importFailParams = {
      whNo: null,
      userId: null,
      abnormalDetailRequests: null,
      isHandled: null,
      isNotified: null,
      handleCase: null,
      warehousingAbnormalSeqNo: null,
    };
    this.importFailForm = this.fb.group(this.importFailParams);

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    console.log(`init-params= ${JSON.stringify(this.params)}`);
    this.importFailText.importFailReason = this.params.importFailReason;
    this.importFailText.remarks = this.params.remarks;
    this.importFailParams.whNo = this.params.whNo;
    this.importFailParams.warehousingAbnormalSeqNo = this.params.warehousingAbnormalSeqNo;
  }

  submitHandleCase(): void {
    console.log(`Start doing submitHandleCase... \n`);
    /* 實作Import AD */

    if (this.importFailForm.value.handleCase === "1") {
      /* 實作持續追蹤 */
      this.importFailParams.userId = this.userProfile.userName;
      this.importFailParams.abnormalDetailRequests = [];
      this.importFailParams.isHandled = true;
      this.importFailParams.isNotified = null;
      console.log(`Case 1: this.importFailParams=${JSON.stringify(this.importFailParams)} \n this.importFailForm=${JSON.stringify(this.importFailForm.value)} \n`);
      this.loader.show();
      this.warehousingAbnormalService.updateWarehousingAbnormalAndStatusByShippingContinuesToTrackTheAbnormalCase(this.importFailParams, 3).subscribe({
        next: (result: any) => {
          /* 成功送出資料 */
          this.dialogVisibleChange(false);
        },
        error: (error: any) => {
          /* 錯誤處理 */
          this.toastErrorMessage(error.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        }
      });
    } else if (this.importFailForm.value.handleCase === "2") {
      /* 實作結案 */
      this.importFailParams.userId = this.userProfile.userName;
      this.importFailParams.abnormalDetailRequests = [];
      this.importFailParams.isHandled = true;
      this.importFailParams.isNotified = null;
      console.log(`Case 2: this.importFailParams=${JSON.stringify(this.importFailParams)} \n this.importFailForm=${JSON.stringify(this.importFailForm.value)} \n`);
      this.loader.show();
      this.warehousingAbnormalService.submitHaupdateWarehousingAbnormalAndStatusByShippingImportedAdFinishndleCase(this.importFailParams, 4).subscribe({
        next: (result: any) => {
          /* 成功送出資料 */
          this.dialogVisibleChange(false);
        },
        error: (error: any) => {
          /* 錯誤處理 */
          this.toastErrorMessage(error.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        }
      });
    } else {
      this.toastErrorMessage(this.translateService.instant('WarehousingAbnormal.Tracking.ChoiceOfFinishOrContinueTracking'));
    }
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

}
